const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (values.listOfSignatory && values.listOfSignatory.length === 0) {
    errors.alert = 'Necessário informar ao menos um signatário';
  }
  return errors;
};

export default validate;
